import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import download from "js-file-download";
import {Badge} from "primereact/badge";

const InventorydocumentListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [inventorydocuments, setInventorydocuments] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [statusDict, setStatusDict] = useState({});
  const getInitialFilters = () => ({
    document_number: { value: null, matchMode: 'contains' },
    status: { value: null, matchMode: 'contains' },
    partner_name: { value: null, matchMode: 'contains' },
    'company.name': { value: null, matchMode: 'contains' },
    'warehouse_to.name': { value: null, matchMode: 'contains' },
    date: { value: null, matchMode: 'contains' },
    ...(props?.type ? { type: { value: props.type, matchMode: 'equals' } } : {})
  });
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
    // filters: {
    //   type: {value: props.type, matchMode: 'equals'}
    // }
    filters: getInitialFilters()
  });

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    if (loadLazyTimeout.current) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      setLoading(true);
      const lazyParamsWithoutFilters = {
        ...lazyParams,
        filters: {}
      };
      let query = window.App.transformQueryParams(lazyParamsWithoutFilters);
      const filterQuery = buildFilterQuery(lazyParams.filters);
      if (filterQuery) {
        query += `${query.includes('?') ? '&' : '?'}${filterQuery}`;
      }
      if (props.view === 'relocation') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=RELOCATION';
      } 
      else if (props.view === 'pick_list') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=PICK_LIST';
      }
      else if (props.view === 'scrap_note') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=SCRAP_NOTE';
      }
      else if (props.view === 'inventory_count') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=INVENTORY_COUNT';
      }
      else if (props.view === 'return_by_customer') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=RETURN_BY_CUSTOMER';
      }
      else if (props.view === 'return_to_supplier') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=RETURN_TO_SUPPLIER';
      }
      else if (props.view === 'transfer_2st') {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=TRANSFER_2ST';
      }
      else if (props.view === 'transfer_supplier'){
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=TRANSFER_SUPPLIER';
      }
      else if (props.view === 'delivery_note'){
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=DELIVERY_NOTE';
      }

      apiCall('get', '/api/v2/inventory-document' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setInventorydocuments(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _filters = event.filters || {};
    Object.keys(_filters).forEach((key) => {
      if (_filters[key] && !_filters[key].matchMode) {
        _filters[key].matchMode = 'contains';
      }
    });
    setLazyParams(prev => ({
      ...prev,
      first: 0,
      page: 0,
      filters: _filters
    }));
  };
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const downloadInventoryDocument = async (rowData, format) => {
    setLoading(true);
    try {
      const docId = rowData.id;
      const filenameBase = rowData.document_number || `inventory-document-${docId}`;
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/inventory-document/${docId}/download/${format}`,
        {
          responseType: 'blob',
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        }
      );
      download(res.data, `${filenameBase}.${format}`);
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error?.response);
    } finally {
      setLoading(false);
    }
  };

  const isPicker = props?.view === 'search' && !!props?.backlink && !!props?.pickParam;

  const goPick = (rowData) => {
    if (!isPicker) return;
    const pickedId = Number(rowData?.id);
    if (!pickedId) return;
    const base = props.backlink;
    const sep = base.includes('?') ? '&' : '?';
    history.push(`${base}${sep}${props.pickParam}=${pickedId}`);
  };

  const buildFilterQuery = (filters) => {
    const parts = [];
    Object.entries(filters || {}).forEach(([field, config]) => {
      if (!config || config.value === null || config.value === undefined || config.value === '') {
        return;
      }
      if (config.matchMode === 'equals') {
        parts.push(`search[${field}][operator]==`);
        parts.push(`search[${field}][value]=${encodeURIComponent(config.value)}`);
      } else {
        parts.push(`search[${field}][operator]=like`);
        parts.push(`search[${field}][value]=${encodeURIComponent('*' + config.value + '*')}`);
      }
    });
    return parts.join('&');
  };

  const labelForStatus = (status) => {
    const key = String(status || '').toUpperCase();
    const statusItem = statuses.find(item =>
      String(item.key || '').toUpperCase() === key
    );
    return statusItem?.value || status || '';
  };

  const severityForStatus = (status) => {
    switch (String(status || '').toUpperCase()) {
      case 'DRAFT':
        return 'info';

      case 'IN_TRANSIT':
        return 'warning';

      case 'COMPLETED':
        return 'success';

      case 'DELETED':
        return 'danger';

      default:
        return 'info';
    }
  };

  const statusBodyTemplate = (rowData) => {
    const status = rowData?.status;
    return (
      <Badge
        value={labelForStatus(status)}
        severity={severityForStatus(status)}
        style={{ whiteSpace: 'nowrap' }}
      />
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {props.view !== 'transfer_supplier' && (
        <>
          <Button icon="pi pi-file-pdf" className="p-button-secondary p-mr-2"
          tooltip={t('downloadPdf')} tooltipOptions={{position: 'left'}}
          onClick={() => downloadInventoryDocument(rowData, 'pdf')}
          />

          <Button icon="pi pi-file-excel" className="p-button-secondary p-mr-2"
                  tooltip={t('downloadXlsx')} tooltipOptions={{position: 'left'}}
                  onClick={() => downloadInventoryDocument(rowData, 'xlsx')}
          />
        </>
        )}
        {props.view === 'transfer_supplier' && (
          <Button icon="pi pi-file" className="p-button-secondary p-mr-2"
                  tooltip={t('download')} tooltipOptions={{position: 'left'}} disabled={rowData.file === null}
                  onClick={() => {
                    axios.get(
                      process.env.REACT_APP_API_HOST + `/api/v2/file/${rowData.id}/download`,
                      {
                        responseType: 'blob',
                        headers: {
                          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                          'App-Network': localStorage.getItem("networkId")
                        }
                      }
                    ).then(response => {
                      const filename = rowData.document_number ? `${rowData.document_number}.pdf` : `file-${rowData.id}.pdf`;
                      download(response.data, filename);
                    })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      });
                  }}
          />
        )}
        <Button
          icon="pi pi-eye"
          className="p-button p-mr-2"
          tooltip={t('view')}
          tooltipOptions={{ position: 'left' }}
          onClick={() => {
            if (entity === 'inventory-document') {
              history.push('/inventory/' + props.entity + '/read/' + rowData.id + history.location.search);
            }
            // if (entity === 'purchase-order') {
            //   history.push(
            //     '/procurement/purchase-order/read/' + rowData.id + '&return=/procurement/purchase-order'
            //   );
            // }
          }}
        />
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}} disabled={rowData.status === 'COMPLETED'}
                  onClick={() => {
                    if (entity === 'inventory-document') {
                      history.push('/inventory/' + props.entity + '/update/' + rowData.id + history.location.search);
                    }
                    if (entity === 'purchase-order') {
                      history.push('/procurement/purchase-order/' + action + '/' + id + '?update=inventorydocument&inventoryDocumentId=' + rowData.id + '&type=transfer-supplier')
                    }
                  }}/>
        }
        {/*{localStorage.getItem('roles').toString().includes('role_') &&*/}
        {/*  <Button icon="pi pi-trash" className="p-button-danger"*/}
        {/*          tooltip={t('delete')} tooltipOptions={{position: 'left'}}*/}
        {/*          onClick={() => {*/}
        {/*            if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*              setLoading(true);*/}
        {/*              apiCall('delete', '/api/v2/inventory-document/' + rowData.id)*/}
        {/*                .then(response => {*/}
        {/*                  window.App.toastShow('success', 'Sikeres törlés!');*/}
        {/*                  window.App.setState({rerenderInventorydocumentList: Math.random()})*/}
        {/*                })*/}
        {/*                .catch(error => {*/}
        {/*                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
        {/*                })*/}
        {/*                .finally(() => {*/}
        {/*                  setLoading(false);*/}
        {/*                })*/}
        {/*            }*/}
        {/*          }}*/}
        {/*  />*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    apiCall('GET', '/api/v2/dictionary/inventory-document-status')
      .then(response => {
        setStatuses(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    loadLazyData();
  }, [lazyParams, props.view, props.type, window.App.state.rerenderInventorydocumentList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={inventorydocuments} paginator first={lazyParams.first} totalRecords={totalRecords}
                 onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                 className={isPicker ? 'picker-table' : undefined}
                 onRowDoubleClick={(e) => {
                   if (isPicker) goPick(e.data);
                 }}
      >
        {props.view !== 'transfer_supplier' && (
          <Column field="document_number" bodyClassName="col-body-font-bold" header={t('columnDocumentNumber')} sortable filter ></Column>
        )}
        {props.view === 'transfer_supplier' && (
          <Column field="document_number" bodyClassName="col-body-font-bold" header={t('columnDeliveryNoteNumber')} sortable filter></Column>
        )}
        <Column field="status" header={t('columnStatus2')} sortable filter body={statusBodyTemplate}></Column>
        {(props.view === 'delivery_note' || props.view === 'transfer_supplier') && (
          <Column field="partner.name" header={t('columnPartner')} sortable filter filterField='partner_name'></Column>
        )}
         
        {(props.view === 'delivery_note' || props.view === 'transfer_supplier') && (
          <Column field="company.name" header={t('columnCompany')} sortable filter ></Column>
        )}
        <Column field="warehouse_to.name" header={t('columnWarehouse')} sortable filter body={(rowData) => {
          return (
            <>
              {rowData?.warehouse_to?.name || rowData?.warehouse_from?.name || '-'}
            </>
          );
        }}></Column>
        {/*<Column field="type" header={t('columnType')} sortable filter></Column>*/}
        <Column field="date" header={t('columnDate')} sortable filter body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.date)}</>
          )
        }}></Column>
        {!isPicker && (
          <Column body={actionBodyTemplate} className="p-py-0 p-text-right p-text-nowrap" />
        )}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(InventorydocumentListComponent);
